import * as React from 'react';
import FormSelect, { Props as FormSelectProps } from './FormSelect';

interface Props extends FormSelectProps {
    labelProps: {
        labelText: string;
        invalidText?: string;
    };
    helpTextProps?: {
        helpText: string;
    };
}

const FormSelectLabeled = (props: Props) => {
    return (
        <div className={'form-group' + (props.className ? ` ${props.className}` : '')}>
            {/* Hidden input is used to trigger form validation styles */}
            <input
                value={
                    props.selectProps.value === undefined || props.selectProps.value === null
                        ? ''
                        : props.selectProps.value.toString()
                }
                required={props.selectProps.required}
                className="select-validatable-input"
                style={{
                    display: 'none'
                }}
                onChange={() => undefined}      
            />
            <label htmlFor={props.selectProps.id} className="font-weight-bold">
                {props.labelProps.labelText}
            </label>
            <FormSelect
                selectProps={props.selectProps}
                selectOptions={props.selectOptions}
                onChange={props.onChange}
            />
            {props.helpTextProps && (
                <small className="form-text text-muted">{props.helpTextProps.helpText}</small>
            )}
            {props.labelProps.invalidText && (
                <div className="invalid-feedback">{props.labelProps.invalidText}</div>
            )}
        </div>
    );
};

export default FormSelectLabeled;



// WEBPACK FOOTER //
// ./src/components/common/form/SelectLabeled.tsx